/**
 * AI 分类助手侧边栏头部图标集（Figma 分类agent node 12:2915 导出）
 *
 * 统一 16px 线性图标，stroke 用 currentColor 跟随容器配色
 * （头部按钮容器为 #1d2129 + hover 浅灰底）。
 * 消费方：AISidebar（收起）、AIChatHeaderActions（历史会话 / 新会话）。
 */

import React from 'react'

interface HeaderIconProps {
  /** 图标边长（px），默认 16（对齐设计稿 1x） */
  size?: number
}

/** 收起侧边栏 · 双箭头 » */
export const CollapseIcon: React.FC<HeaderIconProps> = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 13.12 13.12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M7.10667 3.28L10.3867 6.56L7.10667 9.84M2.73333 3.28L6.01333 6.56L2.73333 9.84"
      stroke="currentColor"
      strokeWidth="0.975"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

/** 历史会话 · 带回退箭头的时钟 */
export const HistoryIcon: React.FC<HeaderIconProps> = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 13.12 13.12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M1.64 6.56C1.63897 7.68671 2.02469 8.77963 2.73269 9.65611C3.44069 10.5326 4.42807 11.1395 5.5298 11.3754C6.63153 11.6113 7.78086 11.462 8.78569 10.9523C9.79051 10.4426 10.59 9.60345 11.0504 8.57512C11.5109 7.54679 11.6044 6.39158 11.3154 5.30256C11.0264 4.21354 10.3724 3.25671 9.46268 2.59198C8.55296 1.92725 7.44264 1.5949 6.3173 1.65048C5.19196 1.70605 4.1198 2.1462 3.28 2.89733L1.64 4.37333"
      stroke="currentColor"
      strokeWidth="0.975"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.64 1.64V4.37333H4.37333M6.56 3.82667V6.56L8.2 7.65333"
      stroke="currentColor"
      strokeWidth="0.975"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

/** 新会话 · 加号 */
export const NewConversationIcon: React.FC<HeaderIconProps> = ({
  size = 16
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 13.12 13.12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M6.56 2.73333V10.3867M2.73333 6.56H10.3867"
      stroke="currentColor"
      strokeWidth="0.975"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
